/**
 * labelFormatters.ts
 *
 * Helper functions for formatting severity and confidence as text labels.
 *
 * Requirements: 18.3
 */

/**
 * Format a severity level for display (e.g., "Critical", "High").
 */
export function formatSeverity(severity: string): string {
  switch (severity?.toLowerCase()) {
    case 'material':
      return 'Material';
    case 'curable':
      return 'Curable';
    case 'critical':
      return 'Critical';
    case 'high':
      return 'High';
    case 'medium':
      return 'Medium';
    case 'low':
      return 'Low';
    case 'informational':
      return 'Informational';
    default:
      return 'Unknown';
  }
}

/**
 * Format a confidence level for display (e.g., "High", "Medium").
 */
export function formatConfidence(confidence: string): string {
  switch (confidence?.toLowerCase()) {
    case 'high':
      return 'High';
    case 'medium':
      return 'Medium';
    case 'low':
      return 'Low';
    default:
      return 'Unknown';
  }
}

/**
 * Get a CSS class name for a severity level (for styling).
 */
export function severityClass(severity: string): string {
  switch (severity?.toLowerCase()) {
    case 'material':
      return 'bg-red-100 text-red-800';
    case 'curable':
      return 'bg-yellow-100 text-yellow-800';
    case 'critical':
      return 'bg-red-100 text-red-800';
    case 'high':
      return 'bg-orange-100 text-orange-800';
    case 'medium':
      return 'bg-yellow-100 text-yellow-800';
    case 'low':
      return 'bg-blue-100 text-blue-800';
    case 'informational':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

/**
 * Get a CSS class name for a confidence level (for styling).
 */
export function confidenceClass(confidence: string): string {
  switch (confidence?.toLowerCase()) {
    case 'high':
      return 'bg-green-100 text-green-800';
    case 'medium':
      return 'bg-yellow-100 text-yellow-800';
    case 'low':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}
